import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { NavigationService } from '@core/services/navigation/navigation.service';
import { PushNotificationsService } from '@core/services/push-notifications/push-notifications.service';
import { SocketService } from '@core/services/socket.service';
import { sentry } from 'sentry';
var LoginRedirectComponent = /** @class */ (function () {
    function LoginRedirectComponent(router, socketService, activatedRoute, navigationService, authenticationService, pushNotificationsService) {
        this.router = router;
        this.socketService = socketService;
        this.activatedRoute = activatedRoute;
        this.navigationService = navigationService;
        this.authenticationService = authenticationService;
        this.pushNotificationsService = pushNotificationsService;
        this.redirecting = true;
    }
    LoginRedirectComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, adIdToken, state, parsedState, provider, firstVisibleItem, redirectToDestinationUrl, err_1, queryParams;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        localStorage.removeItem('AUTH_REDIRECT_URL');
                        _a = this.activatedRoute.snapshot.queryParams, adIdToken = _a.id_token, state = _a.state;
                        parsedState = state && JSON.parse(decodeURIComponent(state));
                        provider = state && parsedState.provider;
                        if (!adIdToken || !provider) {
                            throw new Error('No id token provided or provider on url params');
                        }
                        return [4 /*yield*/, this.authenticationService.login({ provider: provider, adIdToken: adIdToken })];
                    case 1:
                        _b.sent();
                        firstVisibleItem = this.navigationService.getFirstVisibleItem(true);
                        redirectToDestinationUrl = localStorage.getItem('REDIRECT_TO_URL_AFTER_LOGIN');
                        location.href = redirectToDestinationUrl || firstVisibleItem.url;
                        if (redirectToDestinationUrl) {
                            localStorage.removeItem('REDIRECT_TO_URL_AFTER_LOGIN');
                        }
                        this.navigationService.showSupplierIndicationPopUpForCurrentMonth();
                        return [4 /*yield*/, this.connectSocketAndPushNotifications()];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _b.sent();
                        this.redirecting = false;
                        if (err_1.message === 'No id token provided or provider on url params') {
                            return [2 /*return*/];
                        }
                        queryParams = this.activatedRoute.snapshot.queryParams;
                        if (!err_1.error.code || !queryParams.error) {
                            sentry.setExtra('error', err_1);
                            sentry.setContext('queryParams', queryParams);
                            sentry.captureException(err_1);
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    LoginRedirectComponent.prototype.connectSocketAndPushNotifications = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.pushNotificationsService.refreshNotificationSubscription()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.socketService.reconnect()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LoginRedirectComponent.prototype.gotoLogin = function () {
        this.router.navigateByUrl('/login');
    };
    return LoginRedirectComponent;
}());
export { LoginRedirectComponent };
